import { API_BASE_URL, getHeaders } from './config'

export async function fetchCertificationRequirements() {
  const response = await fetch(`${API_BASE_URL}/certifications/requirements`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch requirements')
  }
  
  return response.json()
}

export async function fetchCertificationProgress() {
  const response = await fetch(`${API_BASE_URL}/certifications/progress`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch progress')
  }
  
  return response.json()
}

export async function updateCertificationStatus(
  requirementId: string, 
  status: 'not_started' | 'in_progress' | 'completed'
) {
  const response = await fetch(`${API_BASE_URL}/certifications/progress/${requirementId}`, {
    method: 'PUT',
    headers: getHeaders(),
    body: JSON.stringify({ status })
  })
  
  if (!response.ok) {
    throw new Error('Failed to update certification status')
  }
  
  return response.json()
}

export async function fetchCertificationJourney(roleType: string) {
  const response = await fetch(`${API_BASE_URL}/certifications/journey/${roleType}`, {
    headers: getHeaders()
  })
  
  if (!response.ok) {
    throw new Error('Failed to fetch certification journey')
  }
  
  return response.json()
}
